import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const TongaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_16009'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_16009)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M20 0H11.4286V7.46667H0V14H20V0Z'
					fill='#E20F1B'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M5.09552 0.93335C4.91142 0.93335 4.76218 1.08259 4.76218 1.26668V2.80002H3.19076C3.00666 2.80002 2.85742 2.94925 2.85742 3.13335V4.33335C2.85742 4.51744 3.00666 4.66668 3.19076 4.66668H4.76218V6.20002C4.76218 6.38411 4.91142 6.53335 5.09552 6.53335H6.33361C6.51771 6.53335 6.66695 6.38411 6.66695 6.20002V4.66668H8.23837C8.42247 4.66668 8.57171 4.51744 8.57171 4.33335V3.13335C8.57171 2.94925 8.42247 2.80002 8.23837 2.80002H6.66695V1.26668C6.66695 1.08259 6.51771 0.93335 6.33361 0.93335H5.09552Z'
					fill='url(#paint0_linear_2332_16009)'
				/>
			</g>
			<defs>
				<linearGradient
					id='paint0_linear_2332_16009'
					x1='2.85742'
					y1='0.93335'
					x2='2.85742'
					y2='6.53335'
					gradientUnits='userSpaceOnUse'>
					<stop stopColor='#DF101B' />
					<stop
						offset='1'
						stopColor='#C00711'
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default TongaFlagIcon;
